export default __webpack_public_path__ + "static/media/9.287a4496.svg";